import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { schemaOrgWebPage } from '../../utils/ld';
import Facebook from './Facebook';
import Twitter from './Twitter';
function toTitle(title, defaultTitle) {
    if (defaultTitle) {
        return title ? "".concat(title, " : ").concat(defaultTitle) : defaultTitle;
    }
    return title || '';
}
function SEO(_a) {
    var title = _a.title, 
    // pathname,
    url = _a.url, defaultTitle = _a.defaultTitle, defaultDescription = _a.defaultDescription, description = _a.description, 
    // siteUrl,
    defaultBanner = _a.defaultBanner, language = _a.language, twitter = _a.twitter, facebook = _a.facebook, buildTime = _a.buildTime, canonical = _a.canonical, disableDefaultDescription = _a.disableDefaultDescription;
    var seo = {
        title: toTitle(title, defaultTitle),
        description: disableDefaultDescription ? description : description || defaultDescription,
        image: "".concat(defaultBanner),
        url: url || '',
        canonical: canonical,
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Helmet, { title: seo.title || '', children: [_jsx("html", { lang: language || 'ja' }), seo.description && _jsx("meta", { name: "description", content: seo.description }), _jsx("meta", { name: "image", content: seo.image }), seo.canonical && _jsx("link", { rel: "canonical", href: seo.canonical }), _jsx("script", { type: "application/ld+json", children: JSON.stringify(schemaOrgWebPage(url, language, defaultDescription, defaultTitle, buildTime, seo.image)) })] }), _jsx(Facebook, { description: seo.description || '', image: seo.image, title: seo.title || '', type: 'website', url: seo.url, name: facebook || '' }), _jsx(Twitter, { title: seo.title || '', image: seo.image, description: seo.description || '', username: twitter || '' })] }));
}
export default SEO;
//# sourceMappingURL=SEO.js.map